import React from 'react'
import { CellRenderer, CellProps } from '../../../legacy-design-system/grid'
import { AttackEvent } from '../shared'
import { PureQueryOptions } from 'apollo-client'
import { AttackEventRowActionList } from './row-action-list'
import { css } from '@emotion/css'

const actionContainerCss = css`
  margin-left: auto;
  margin-right: 10px;
`

interface AttackEventRowActionListProps {
  organizationID: string
  refetchQueries: PureQueryOptions[]
  refresh: () => Promise<any>
  isFreemium: boolean
  refreshGridData: () => void
}

export const getAttackEventRowActionsCellRenderer =
  ({
    refreshGridData,
    organizationID,
    refetchQueries,
    refresh,
    isFreemium
  }: AttackEventRowActionListProps): CellRenderer<AttackEvent> =>
  ({
    rowData,
    isRowHovered,
    getCellContentProps
  }: CellProps<AttackEvent> & {
    isRowHovered: boolean
  }): React.ReactNode => {
    return (
      <div {...getCellContentProps({ className: actionContainerCss })}>
        <AttackEventRowActionList
          organizationUuid={organizationID}
          rowData={rowData}
          refreshGridData={refreshGridData}
          refetchQueries={refetchQueries}
          refresh={refresh}
          isFreemium={isFreemium}
          isRowHovered={isRowHovered}
        />
      </div>
    )
  }
